import React from "react";
import './index.scss';

const LoginIllustrations: React.FC = () => (
  <div className="login-illustration">
    <div className="login-tagline">
      <p className="login-tagline-eyebrow">HOSPITALITY OPERATIONS PLATFORM</p>
      <h2 className="login-tagline-heading">
        Manage every<br />
        stay with<br />
        <span className="login-tagline-accent">precision.</span>
      </h2>
      <div className="login-tagline-rule" />
      <p className="login-tagline-desc">
        Streamline properties, reservations,<br />
        and revenue — all in one place.
      </p>
    </div>
  </div>
);

export default LoginIllustrations;
